import React, { FC } from 'react'
import cx from 'classnames'
import { useTranslation } from 'react-i18next'

import * as SC from './styled'

export type FooterProps = {
  className?: string
}

const Footer: FC<FooterProps> = ({ className }) => {
  const { t } = useTranslation()

  const handleCookieSettings = () => {
    // OneTrust cookie modal trigger (like NDA frontend)
    if (window.OneTrust && window.OneTrust.ToggleInfoDisplay) {
      window.OneTrust.ToggleInfoDisplay()
    } else if (window.Optanon && window.Optanon.ToggleInfoDisplay) {
      window.Optanon.ToggleInfoDisplay()
    }

    // GTM tracking
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'cookie_settings_click',
        action: 'click',
        category: 'cookie',
        label: 'cookie_settings',
      })
    }
  }

  const handleCookiePolicy = () => {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'cookie_policy_click',
        action: 'click',
        category: 'cookie',
        label: 'cookie_policy',
      })
    }

    window.open(
      'https://www.balenciaga.com/legal/politique-des-cookies/cookie-policy.html',
      '_blank',
      'noopener,noreferrer'
    )
  }

  return (
    <SC.Container className={cx(className)}>
      <SC.CookieButton onClick={handleCookieSettings}>{t('footer.cookieSettings')}</SC.CookieButton>
      <SC.Separator>|</SC.Separator>
      <SC.CookiePolicyButton onClick={handleCookiePolicy}>
        {t('footer.cookiePolicy')}
      </SC.CookiePolicyButton>
      <SC.Separator>|</SC.Separator>
      <SC.Copyright>© 2025 Balenciaga</SC.Copyright>
    </SC.Container>
  )
}

export default Footer
